module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hotsite_menu"
    }
  }, [_c('div', {
    staticClass: "dropdown pull-right",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_vm._m(0), (_vm.isOpen) ? _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "mobile_menu"
    }
  }, _vm._l((_vm.links), function(link, id) {
    return _c('li', {
      key: link.id
    }, [(link.rota) ? _c('router-link', {
      attrs: {
        "to": {
          name: link.rota
        }
      }
    }, [_vm._v(_vm._s(link.texto))]) : (link.url) ? _c('a', {
      attrs: {
        "href": link.url,
        "target": "_blank",
        "noopener": "noopener"
      }
    }, [_vm._v(_vm._s(link.texto))]) : _vm._e()], 1)
  }), 0) : _vm._e()]), _c('hr', {
    staticClass: "-full"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "id": "mobile_menu",
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v("   Navegue aqui")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c77ddca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/HotsiteMenu.vue
// module id = 482
// module chunks = 0